var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 31.999"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-linkedin-in",
    d: "M7.163 31.999H.529V10.635h6.634zM3.842 7.72a3.86 3.86 0 113.842-3.878A3.875 3.875 0 013.842 7.72zm28.151 24.279h-6.62v-10.4c0-2.479-.05-5.657-3.449-5.657-3.449 0-3.978 2.693-3.978 5.479v10.578h-6.627V10.635h6.363v2.914h.093a6.971 6.971 0 016.277-3.45c6.714 0 7.948 4.421 7.948 10.164v11.736z",
    fill: "currentColor"
  })));
}
export default SvgLinkedinFull;